<template>
  <base-module
    :definition="heartRateDefinitions"
    :connected="heartRateStatus.connected"
    :connecting="heartRateStatus.connecting"
    :content-active="heartRateStatus.connected && !heartRateStatus.connecting"
  >
    <template #title> {{ t('modules.heartrate.index') }} </template>
    <template #config>
      <div
        class="heartrate-module__settings"
        @click="changeDevice = true"
      >
        <BfIcon
          icon="/icons/01-Interface Essential/12-Settings/cog.svg"
          :color="Colors.Light"
        />
      </div>
    </template>

    <template #middle>
      <n-progress
        class="heartrate__indicator"
        type="line"
        :height="12"
        :show-indicator="false"
        :percentage="heartRateAsPercentage"
      />
    </template>

    <template #bottom>
      <n-form
        ref="formRef"
        label-placement="left"
      >
        <n-form-item
          :label="t('modules.heartrate.index')"
          class="heartrate__output"
        >
          <n-input-group>
            <n-input-number
              :value="heartRateValue"
              :show-button="false"
              readonly
            />

            <n-input-group-label>{{ heartRate.unit }}</n-input-group-label>
          </n-input-group>
        </n-form-item>
      </n-form>

      <div
        v-if="changeDevice"
        class="heartrate-module__select"
      >
        <PairDevices
          :type="deviceType.heartRate"
          @close="changeDevice = false"
        />
      </div>
    </template>
  </base-module>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import BaseModule from './BaseModule.vue'
import {
  NInputNumber,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NProgress,
  NFormItem,
} from 'naive-ui'
import { useI18n } from 'vue-i18n'

//Store
import { useMqttStore } from '@/store/mqttStore'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'
import { BfIcon, Colors } from '@finetic/bikefitting-ui'
import { deviceType } from '@/types/device'
import PairDevices from '@/components/controls/PairDevices.vue'

import { heartRateDefinitions, heartRate } from '@/mqttDefinitions'
import {
  valueAsPercentage,
  HEARTRATE_MIN,
  HEARTRATE_MAX,
} from '@/outputVariables'

const { t } = useI18n()
const mqttStore = useMqttStore()
const deviceStore = useDeviceStore()

const changeDevice = ref(false)

const { getMessageOnTopic } = storeToRefs(mqttStore)
const { heartRateStatus } = storeToRefs(deviceStore)

//Data init
const heartRateValue = computed(() => {
  return getMessageOnTopic.value(heartRate)
})

const heartRateAsPercentage = computed(() => {
  return valueAsPercentage(heartRateValue.value, HEARTRATE_MAX, HEARTRATE_MIN)
})
</script>

<style lang="scss">
.heartrate-module {
  &__settings {
    opacity: 0.6;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  &__current {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 2.4rem;
  }

  &__select {
    display: block;
    padding-top: 2.4rem;
  }

  &__reconnect-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
}
</style>
